module.exports = __webpack_public_path__ + "static/media/diary1.075d76a1.png";